import { render, staticRenderFns } from "./CompanyVehicleView.vue?vue&type=template&id=15713cc0"
import script from "./CompanyVehicleView.vue?vue&type=script&lang=js"
export * from "./CompanyVehicleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports